<template>
  <div class="avoid-break-inside">
    <h2 name="hotelFeatures" class="title is-size-4">{{ $t('general.hotel-features') }}</h2>
    <!-- this is to ensure backwards compatibilty through all versions, can be removed in future iterations -->
    <b-taglist>
      <b-tag type="is-dark" class="my-2 is-size-6-touch" size="is-large" rounded v-for="f in features" :key="f.id">
        <div v-if="f.feature > 0">{{ $t(`features.${f.feature}`) }} {{ f.additionalInformation }}</div>
        <div v-if="f.feature == 0">
          {{ f.displayName }}
        </div>
      </b-tag>
    </b-taglist>
    <p class="mt-4 is-size-7">{{ $t('product.feature-info') }}</p>
  </div>
</template>

<script>
export default {
  name: 'HotelFeatures',
  props: {
    features: Array,
  },
}
</script>

<style scoped lang="scss"></style>
